// extracted by mini-css-extract-plugin
module.exports = {"leftSectionWrapper":"left-section_leftSectionWrapper__YdWQA","houseImg":"left-section_houseImg__nNGjK","footnotes":"left-section_footnotes__U2JK7"};